<template>
  <div>
    <validation-observer no-validate :ref="`${code}-validator`">
      <section-title content="V. Resultados" :has-line="true" />
      <p class="p-1 bold">
        Los equipos recomendados, que el Comité de Programación y Ubicación
        escolar seleccione para compra, han de ser considerados indispensables y
        necesarios al logro de las metas educativas establecidas en el Programa
        Educativo Individualizado (PEI) del estudiante. Los equipos presentados
        a continuación son sugeridos a base de las destrezas que posee el
        estudiante, y no necesariamente constituyen determinaciones, por lo que
        así deben ser considerados por el COMPU escolar. Alternativas similares
        pueden ser avaladas por este Comité.
      </p>

      <div class="d-flex flex-column">
        <div class="question-element">
          <div class="item-pane color-secondary-6">
            <div class="question-line col py-3 p-0">
              <b class="mb-0">
                ¿Es necesario la recomendación de Equipos de Asistencia
                Tecnológica para el Estudiante?
              </b>
            </div>
            <div class="align-items-end d-flex p-0 custom-radio-container">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-radio
                  is-question-list
                  :key="value.isRecommendationNeeded"
                  v-model="value.isRecommendationNeeded"
                  :options="yesNoOptions(value.isRecommendationNeeded)"
                  class="radio-button-container"
                  custom-error-msg="Favor de seleccionar una opción."
                  :error="Boolean(errors[0])"
                  :disabled="isReadOnly || value.referralTypeId == 7"
                />
              </validation-provider>
            </div>
          </div>
        </div>

        <div
          v-if="value.isRecommendationNeeded == false"
          class="mt-4 pb-4 pr-2"
        >
          <div>Especifique:</div>
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              class="mt-2"
              :placeholder="'Escribe un comentario'"
              :maxlength="3000"
              v-model="value.recommendationNeededComment"
              show-char-count
              :disabled="isReadOnly"
              :error="errors[0]"
              custom-error-msg="Favor de escribir un comentario."
              :count-classes="['d-block text-right']"
              :rows="5"
            />
          </validation-provider>
        </div>
      </div>

      <div v-if="value.isRecommendationNeeded == true">
        <div class="row" v-if="!isReadOnly && value.referralTypeId != 7">
          <div v-if="!enableDropDownSelection" class="col-md-3 col-12">
            <label class="color-secondary-6 font-14 font-weight-normal mr-2">
              Nombre del Equipo:
            </label>
            <div class="color-black font-16 font-weight-bold">
              <validation-provider
                :rules="validateName ? 'required' : ''"
                v-slot="{ errors }"
              >
                <custom-input
                  placeholder="Nombre del Equipo"
                  type="text"
                  v-model="equipmentModel.equipmentName"
                  :error="errors[0]"
                  :disabled="isReadOnly"
                  :custom-error-msg="'El nombre del equipo es requerido'"
                />
              </validation-provider>
            </div>
          </div>

          <div v-else class="row col-6  mt-5">
            <div class="col-md col-12 mt-0">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Clasificación de Cumplimiento:
              </label>
              <div class="color-black font-16 font-weight-bold">
                <validation-provider
                  :rules="validateName ? 'required' : ''"
                  v-slot="{ errors }"
                >
                  <custom-drop-down
                    :options="classifications"
                    fieldkey="id"
                    fieldname="name"
                    :error="errors[0]"
                    :custom-error-msg="
                      'La clasificación de cumplimiento es requerida'
                    "
                    placeholder="Seleccione una clasificación"
                    class="mb-4 bold-label"
                    v-model="equipmentModel.clasification"
                    @input="onChangeClasification"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="col-md col-12 mt-0">
              <label class="color-secondary-6 font-14 font-weight-normal mr-2">
                Nombre del Equipo MiPE:
              </label>
              <div class="color-black font-16 font-weight-bold">
                <validation-provider
                  :rules="validateName ? 'required' : ''"
                  v-slot="{ errors }"
                >
                  <custom-drop-down
                    :options="
                      equipmentList.filter(
                        (x) => !equipments.some((t) => t.catalogId == x.id)
                      )
                    "
                    fieldkey="id"
                    fieldname="name"
                    :error="errors[0]"
                    :custom-error-msg="'El nombre del equipo es requerido'"
                    placeholder="Seleccione un equipo"
                    class="mb-4 bold-label"
                    v-model="equipmentModel.catalog"
                  />
                </validation-provider>
              </div>
            </div>
          </div>

          <div
            :class="{
              'col-sm mt-6': enableDropDownSelection,
              'col-sm mt-3': !enableDropDownSelection,
            }"
          >
            <action-button
              :class="{
                'mt-6': enableDropDownSelection,
                'mt-3': !enableDropDownSelection,
              }"
              class="mt-0"
              id="modal-btn-cancelar"
              variant="success"
              i="fas fa-file-plus"
              @click="addEquipment()"
            >
              Añadir Equipo
            </action-button>
          </div>
        </div>

        <div class="mt-4">
          <div
            :key="index"
            v-for="(item, index) in equipments"
            class="mt-4 "
            :has-toggle="false"
          >
            <custom-collapse class="mt-2 px-3 mx-1" :id="'tab-' + index">
              <custom-collapse-item
                :title="item.equipmentName"
                :parent-id="'tab-' + index"
                :expanded="item.expanded"
                :disabled="isReadOnly || value.referralTypeId == 7"
                :class="{ 'border border-danger': !item.isValid }"
                :button-icon="'far fa-times-circle color-red'"
                :expanded-icon="'fas fa-plus-circle color-black--3'"
                @actionButtonClick="removeEquipment(index)"
                @expandButtonClick="() => {}"
              >
                <div class="row">
                  <div class="col-12 px-4">
                    <div class="col-md-12 col-12 col-spacing student-spacing">
                      <label
                        class="color-secondary-6 font-14 font-weight-normal mr-2"
                      >
                        Descripción:
                      </label>
                      <div class="color-black font-16 font-weight-bold">
                        <validation-provider
                          :rules="'required'"
                          v-slot="{ errors }"
                        >
                          <custom-text-area
                            class="mt-2"
                            v-model="item.suggestedEquipmentDescription"
                            :placeholder="'Comentario'"
                            :maxlength="100000"
                            :disabled="isReadOnly"
                            :count-classes="['d-block text-right']"
                            :rows="5"
                            :error="errors[0]"
                            :custom-error-msg="'La Descripción es requerida'"
                          />
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 px-4 mt-4">
                    <div class="col-md-12 col-12 col-spacing student-spacing">
                      <label
                        class="color-secondary-6 font-14 font-weight-normal mr-2"
                      >
                        Necesidades Identificadas:
                      </label>
                      <div class="color-black font-16 font-weight-bold">
                        <validation-provider
                          :rules="'required'"
                          v-slot="{ errors }"
                        >
                          <custom-text-area
                            class="mt-2"
                            v-model="item.identifiedNeeds"
                            :placeholder="'Comentario'"
                            :maxlength="3000"
                            :disabled="isReadOnly"
                            :count-classes="['d-block text-right']"
                            :rows="5"
                            show-char-count
                            :error="errors[0]"
                            :custom-error-msg="'Este campo es requerido'"
                          />
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 px-4 mt-2">
                    <div class="col-md-12 col-12 col-spacing student-spacing">
                      <label
                        class="color-secondary-6 font-14 font-weight-normal mr-2"
                      >
                        Justificación/Estrategias:
                      </label>
                      <div class="color-black font-16 font-weight-bold">
                        <validation-provider
                          :rules="'required'"
                          v-slot="{ errors }"
                        >
                          <custom-text-area
                            class="mt-2"
                            v-model="item.justification"
                            :placeholder="'Comentario'"
                            :maxlength="3000"
                            :disabled="isReadOnly"
                            show-char-count
                            :count-classes="['d-block text-right']"
                            :rows="5"
                            :error="errors[0]"
                            :custom-error-msg="'Este campo es requerido'"
                          />
                        </validation-provider>
                      </div>
                    </div>
                  </div>

                  <div class="col-6 px-5">
                    <span class="bold">
                      Otros Servicios y Consideraciones
                    </span>
                    <div class="row">
                      <div class="col-12 mt-3">
                        <checkbox
                          :disabled-bg-color="'bg-dark-gray'"
                          :checked-bg-color="'bg-success'"
                          :icon="'fal fa-check'"
                          :text="'Requiere instalación'"
                          v-model="equipments[index].requireInstallation"
                          :disabled="isReadOnly"
                        />
                      </div>
                      <div class="col-12 mt-3">
                        <checkbox
                          :disabled-bg-color="'bg-dark-gray'"
                          :checked-bg-color="'bg-success'"
                          :icon="'fal fa-check'"
                          :text="'Requiere configuración'"
                          v-model="equipments[index].requireConfiguration"
                          :disabled="isReadOnly"
                        />
                      </div>
                      <div class="col-12 mt-3">
                        <checkbox
                          :disabled-bg-color="'bg-dark-gray'"
                          :checked-bg-color="'bg-success'"
                          :icon="'fal fa-check'"
                          :text="'Requiere capacitación y/o adiestramiento'"
                          v-model="equipments[index].requireTraining"
                          :disabled="isReadOnly"
                        />
                      </div>
                      <div class="col-12 mt-3">
                        <checkbox
                          :disabled-bg-color="'bg-dark-gray'"
                          :checked-bg-color="'bg-success'"
                          :icon="'fal fa-check'"
                          :text="
                            'Requiere de asesoría para implementación en el currículo'
                          "
                          v-model="equipments[index].requireAdvisory"
                          :disabled="isReadOnly"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <span class="bold">Uso Sugerido</span>
                    <div class="row">
                      <div class="col-12 mt-3">
                        <checkbox
                          :disabled-bg-color="'bg-dark-gray'"
                          :checked-bg-color="'bg-success'"
                          :icon="'fal fa-check'"
                          :text="'Escuela'"
                          v-model="equipments[index].usedInSchool"
                          :disabled="isReadOnly"
                        />
                      </div>
                      <div class="col-12 mt-3">
                        <checkbox
                          :disabled-bg-color="'bg-dark-gray'"
                          :checked-bg-color="'bg-success'"
                          :icon="'fal fa-check'"
                          :text="'Hogar'"
                          v-model="equipments[index].usedAtHome"
                          :disabled="isReadOnly"
                        />
                      </div>
                      <div class="col-12 mt-3">
                        <checkbox
                          :disabled-bg-color="'bg-dark-gray'"
                          :checked-bg-color="'bg-success'"
                          :icon="'fal fa-check'"
                          :text="'Terapia'"
                          v-model="equipments[index].usedInTherapy"
                          :disabled="isReadOnly"
                        />
                      </div>
                      <div class="col-12 mt-3">
                        <div class="row">
                          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                            <checkbox
                              :disabled-bg-color="'bg-dark-gray'"
                              :checked-bg-color="'bg-success'"
                              :icon="'fal fa-check'"
                              :text="'Otros'"
                              v-model="equipments[index].usedInOthers"
                              :disabled="isReadOnly"
                            />
                          </div>
                          <div
                            v-if="item.usedInOthers == true"
                            class="col-lg-8 col-md-8 col-xs-12"
                          >
                            <custom-input
                              v-model="item.usedInOtherDescription"
                              class="w-100"
                              :disabled="isReadOnly"
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-12 mt-3">
                        <validation-provider
                          v-slot="{ errors }"
                          :rules="
                            !item.usedInSchool &&
                            !item.usedAtHome &&
                            !item.usedInTherapy &&
                            !item.usedInOthers
                              ? 'required'
                              : ''
                          "
                        >
                          <error
                            v-if="errors[0]"
                            :message="
                              'Se requiere por lo menos un uso sugerido'
                            "
                            variant="no-border"
                          />
                        </validation-provider>
                      </div>
                    </div>
                  </div>
                </div>
              </custom-collapse-item>
            </custom-collapse>
          </div>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import mixAlert from '@/mixins/alert.mixin';
import SectionTitle from 'SectionTitle';
import CustomRadio from '@/components/common/CustomRadioBorder';
import CustomTextArea from '@quisit/custom-text-area';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import referralsandequipmentsApi from '@/services/api/referralsandequipments.api';
import referralService from '@/services/api/referralsandequipments.api';
import TABS from '@/utils/constants/evaluationTabs';
import Error from 'custom-error';
import Checkbox from 'CheckBox';
import inventoryCatalogService from '@/services/api/inventorycatalog.api';
import utils from '@/utils/utilities';
import CustomDropDown from '@/components/common/form/CustomDropDown';
import { getSysparameterByNames } from '@/services/api/sysparameter.api';

export default {
  name: 'TabV',
  components: {
    SectionTitle,
    CustomRadio,
    CustomTextArea,
    CustomInput,
    ActionButton,
    CustomCollapse,
    CustomCollapseItem,
    Error,
    Checkbox,
    CustomDropDown,
  },
  mixins: [mixAlert],
  props: {
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    code: {
      type: String,
      default: () => '',
    },
    referralId: {
      type: Number,
      default: () => 0,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      enableDropDownSelection: false,
      equipmentList: [],
      classifications: [],
      validateName: false,
      value: {
        isRecommendationNeeded: true,
        recommendationNeededComment: '',
        referralTypeId: null,
      },
      equipmentModel: {
        equipmentName: null,
        catalog: null,
        clasification: null,
      },
      options: [
        { label: 'Sí', value: true, check: false },
        { label: 'No', value: false, check: false },
      ],
      equipments: [],
    };
  },
  computed: {
    yesNoOptions() {
      return (checked) => [
        { label: 'SI', value: true, check: checked === true },
        { label: 'NO', value: false, check: checked === false },
      ];
    },
  },
  async mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      await this.getInfo();
      this.$emit('loaded', TABS.V);
    },
    async getInfo() {
      var { data: param } = await getSysparameterByNames({
        parameterNames: ['TechAssistanceServicesInventoryFlow'],
      });

      this.enableDropDownSelection =
        param[0].staticValue && param[0].staticValue.toLowerCase() === 'true';

      var {
        data: classifications,
      } = await referralsandequipmentsApi.getEquipmentClassifications();
      this.classifications = classifications;

      var { data } = await referralsandequipmentsApi.getRecommendations(
        this.referralId
      );
      this.value.isRecommendationNeeded = data.isRecommendationNeeded;
      this.value.recommendationNeededComment = data.recommendationNeededComment;

      this.value.referralTypeId = data.referralTypeId;

      data.recommendations.forEach((item) => {
        this.equipments.push({
          suggestedEquipmentDescription: item.suggestedEquipmentDescription,
          identifiedNeeds: item.identifiedNeeds,
          justification: item.justification,
          requireInstallation: item.requireInstallation,
          requireConfiguration: item.requireConfiguration,
          requireTraining: item.requireTraining,
          requireAdvisory: item.requireAdvisory,
          usedInSchool: item.usedInSchool,
          usedAtHome: item.usedAtHome,
          usedInTherapy: item.usedInTherapy,
          usedInOthers: item.usedInOthers,
          usedInOtherDescription: item.usedInOtherDescription,
          id: item.id,
          equipmentName: item.equipmentName,
          equipment: item.equipmentId,
          isValid: true,
          catalogId: item.catalogId,
        });
      });
    },
    async onChangeClasification(classification) {
      this.equipmentList = [];
      this.equipmentModel.catalog = null;

      if (!classification) {
        return;
      }

      const {
        data: equipments,
      } = await inventoryCatalogService.getFilterOptions(classification.id);
      this.equipmentList = equipments;
    },
    async addEquipment() {
      this.validateName = true;
      this.validateItems();
      await utils.sleep(200);
      var isValid = await this.$refs[`${this.code}-validator`].validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Por favor completa los campos requeridos.',
          'error'
        );

        return false;
      }

      this.equipments.push({
        equipmentName:
          this.equipmentModel.equipmentName ??
          this.equipmentModel.catalog?.name,
        catalogId: this.equipmentModel.catalog?.id,
        suggestedEquipmentDescription: null,
        identifiedNeeds: null,
        justification: null,
        requireInstallation: false,
        requireConfiguration: false,
        requireTraining: false,
        requireAdvisory: false,
        usedInSchool: false,
        usedAtHome: false,
        usedInTherapy: false,
        usedInOthers: false,
        usedInOtherDescription: null,
        isValid: true,
      });
      this.equipmentModel.equipmentName = null;
      this.equipmentModel.catalog = null;
      this.$refs[`${this.code}-validator`].reset();
    },
    async removeEquipment(index) {
      if (
        this.equipments[index].suggestedEquipmentDescription != null ||
        this.equipments[index].identifiedNeeds != null ||
        this.equipments[index].justification != null ||
        this.equipments[index].usedInOtherDescription != null ||
        this.equipments[index].requireInstallation != false ||
        this.equipments[index].requireConfiguration != false ||
        this.equipments[index].requireTraining != false ||
        this.equipments[index].requireAdvisory != false ||
        this.equipments[index].usedInSchool != false ||
        this.equipments[index].usedAtHome != false ||
        this.equipments[index].usedInTherapy != false ||
        this.equipments[index].usedInOthers != false
      ) {
        const isConfirmed = await this.ShowCancelModal(
          'Confirmación',
          `¿Está seguro que desea remover el equipo ${this.equipments[index].equipmentName}, se eliminarán los datos suministrados hasta ahora?`,
          'Sí',
          'No'
        );
        if (isConfirmed) {
          this.equipments.splice(index, 1);
        }
      } else {
        this.equipments.splice(index, 1);
      }
    },
    async validate() {
      this.validateName = false;
      await utils.sleep(200);
      const valid = await this.$refs[`${this.code}-validator`].validate();

      const isValidEquipments = this.value.isRecommendationNeeded
        ? this.equipments.length > 0
        : true;
      return {
        valid: valid && isValidEquipments,
        message: valid && isValidEquipments ? '' : 'Resultados',
      };
    },
    async save(showMessage = true) {
      const data = {
        ...this.value,
        recommendations: this.equipments,
      };

      referralService
        .saveStudentRecommendations(this.referralId, data)
        .then(async () => {
          if (showMessage) {
            this.ShowToast(
              'Éxito',
              'Información ha sido guardada exitosamente.',
              'success'
            );
            this.equipments = [];
            this.initData();
          }
        })
        .catch((error) => {
          this.ShowToast('Alerta', error?.response?.data.message, 'error');
        });
    },
    validateItems() {
      this.equipments.forEach((element) => {
        element.isValid = true;

        if (
          element.suggestedEquipmentDescription == null ||
          element.identifiedNeeds == null ||
          element.justification == null ||
          (element.usedInSchool == false &&
            element.usedAtHome == false &&
            element.usedInTherapy == false &&
            element.usedInOthers == false)
        ) {
          element.isValid = false;
        }
      });
    },
  },
};
</script>

<style scoped>
.item-pane {
  justify-content: space-between;
  min-width: 50%;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}

.question-line p {
  padding-bottom: 0px;
}

.question-line p >>> p {
  margin-bottom: 0px !important;
}

.radio-button-container >>> .cr-icon {
  opacity: 1 !important;
}

.custom-control-input,
.custom-control-label {
  cursor: pointer;
}
</style>
